import { Component, OnInit, DoCheck, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SalesGroupOwnerService } from '../../../service/sales-group-owner/sales-group-owner.service';
import { TypeTaxService } from '../../../service/type-tax/type-tax.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9168',
  templateUrl: './wa9168.component.html',
  styleUrls: ['./wa9168.component.scss']
})
export class Wa9168Component implements OnInit, OnChanges, DoCheck {
  public componentTitle = 'WA9168:荷主別売上摘要マスタ修正';
  public typetaxs: any;
  public ownerId: number;
  public ownerTx: string;
  public salesgroupId: number;
  public salesgroupTx: string;
  public unitpricedispNr: FormControl;
  public typetaxCd: FormControl;
  public validation = validation;
  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  private openotherwindow: boolean = false;
  @Input() rowData: object = [];
  @Output() onSubmitClick = new EventEmitter();

  private isDelayHide = true;
  public unitpricedispNrCls = '';
  public typetaxCdCls = '';

  constructor(
    private salesGroupOwnerService: SalesGroupOwnerService,
    private typetaxService: TypeTaxService,
    private commonService: CommonService,
  ) {
    sessionStorage.removeItem('wa9168openotherwindow');
    const salesgroupowner: object = this.rowData;
    this.ownerId = salesgroupowner['ownerId'];
    this.ownerTx = salesgroupowner['ownerTx'];
    this.salesgroupId = salesgroupowner['salesgroupId'];
    this.salesgroupTx = salesgroupowner['salesgroupTx'];
    var unitpricedispNr = salesgroupowner['unitpricedispNr'];
    var typetaxCd = salesgroupowner['typetaxCd'];
    this.unitpricedispNr = new FormControl(unitpricedispNr, [
      Validators.pattern(validation.decimal_2),
      Validators.max(validation.unitpricedispNr.maxNr),
      Validators.min(validation.unitpricedispNr.minNr),
    ]),
      this.typetaxCd = new FormControl(typetaxCd, Validators.required);

    this.typetaxService
      .get()
      .then(__outputJson => {
        this.typetaxs = __outputJson.typetaxs;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {

  }

  onSubmit() {
    let errors = false;
    if (this.unitpricedispNr.errors !== null) {
      this.unitpricedispNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typetaxCd.errors !== null) {
      this.typetaxCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    this.salesGroupOwnerService
      .put(
        this.ownerId,
        this.salesgroupId,
        this.unitpricedispNr.value,
        this.typetaxCd.value,
        'wa9168'
      )
      .then(outputJson => {
        this.cancel();
        this.onSubmitClick.emit();
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  change(event) {
    this.errorInfo = '';

  }

  ngDoCheck() {
    if (sessionStorage.getItem('wa9168openotherwindow') === 'open') {
      this.openotherwindow = true;
      this.isDelayHide = false;
    }

    if (this.unitpricedispNr.errors) {
      this.working = false;
      this.unitpricedispNrCls = 'error';
      return;
    }
    if (this.typetaxCd.value !== this.rowData['typetaxCd']) {
      this.typetaxCdCls = 'active';
    } else {
      this.typetaxCdCls = '';
    }
    if (this.unitpricedispNr.value !== this.rowData['unitpricedispNr']) {
      if (this.unitpricedispNr.value != null && this.unitpricedispNr.value > 0) {
        this.unitpricedispNrCls = 'active';
      }
      else
        this.unitpricedispNrCls = '';
    } else {
      this.unitpricedispNrCls = '';
    }
    if (this.typetaxCdCls == 'active' || this.unitpricedispNrCls == 'active') {
      this.working = true;
    } else {
      this.working = false;
    }
  }


  ngOnChanges() {
    if (this.rowData !== undefined) {
      const salesgroupowner: object = this.rowData;
      this.ownerId = salesgroupowner['ownerId'];
      this.ownerTx = salesgroupowner['ownerTx'];
      this.salesgroupId = salesgroupowner['salesgroupId'];
      this.salesgroupTx = salesgroupowner['salesgroupTx'];
      var unitpricedispNr = salesgroupowner['unitpricedispNr'];
      var typetaxCd = salesgroupowner['typetaxCd'];
      this.unitpricedispNr = new FormControl(unitpricedispNr, [
        Validators.pattern(validation.decimal_2),
        Validators.max(validation.unitpricedispNr.maxNr),
        Validators.min(validation.unitpricedispNr.minNr),
      ]),
        this.typetaxCd = new FormControl(typetaxCd, Validators.required);
    }
  }

  cancel() {
    sessionStorage.removeItem('wa9168openotherwindow');
    this.openotherwindow = false;
    setTimeout(() => {
      this.isDelayHide = true;
    }, 300);
    this.errorInfo = '';
    this.working = false;
    this.onSubmitClick.emit();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9168/wa9168.component.ts